export default __webpack_public_path__ + "static/media/testimonial3.ae3bc07b.png";